import { render, staticRenderFns } from "./RoundControlPointConfig.vue?vue&type=template&id=9bc0adcc"
import script from "./RoundControlPointConfig.vue?vue&type=script&lang=js"
export * from "./RoundControlPointConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports